// language.js
const translations = {
  // Home Page
  h1Title: {
    en: "Zielona Chatka",
    pl: "Zielona Chatka",
  },
  pSubtitle: {
    en: "Kotelnica nr II, 34-405 Białka Tatrzańska",
    pl: "Kotelnica nr II, 34-405 Białka Tatrzańska",
  },
  orderOnline: {
    en: "Order Online",
    pl: "Zamów Online",
  },
  orderNow: {
    en: "Order Now",
    pl: "Zamów Teraz",
  },
  menu: {
    en: "Menu",
    pl: "Menu",
  },
  drinks: {
    en: "Drinks",
    pl: "Napoje",
  },
  alcohol: {
    en: "Alcohol",
    pl: "Alkohol",
  },
  back: {
    en: "Back",
    pl: "Wstecz",
  },
  location: {
    en: "Location",
    pl: "Lokalizacja",
  },
  
  // Navigation
  home: {
    en: "Home",
    pl: "Strona Główna",
  },
  about: {
    en: "About",
    pl: "O Nas",
  },
  information: {
    en: "Information",
    pl: "Informacje",
  },
  order: {
    en: "Order",
    pl: "Zamów",
  },
  cart: {
    en: "Cart",
    pl: "Koszyk",
  },
  myCart: {
    en: "My Cart",
    pl: "Mój Koszyk",
  },
  account: {
    en: "Account",
    pl: "Konto",
  },
  login: {
    en: "Login",
    pl: "Zaloguj się",
  },
  logout: {
    en: "Logout",
    pl: "Wyloguj się",
  },
  logOut: {
    en: "Log out",
    pl: "Wyloguj się",
  },
  dashboard: {
    en: "Dashboard",
    pl: "Panel",
  },
  
  // Common
  welcome: {
    en: "Welcome",
    pl: "Witamy",
  },
  language: {
    en: "Language",
    pl: "Język",
  },
  changeLanguage: {
    en: "Change Language",
    pl: "Zmień Język",
  },
  selectLanguage: {
    en: "Select Language",
    pl: "Wybierz Język",
  },
  english: {
    en: "English",
    pl: "Angielski",
  },
  polish: {
    en: "Polish",
    pl: "Polski",
  },
  
  // Buttons
  submit: {
    en: "Submit",
    pl: "Wyślij",
  },
  acceptAll: {
    en: "Accept all",
    pl: "Zaakceptuj wszystkie",
  },
  rejectNonEssential: {
    en: "Reject non-essential",
    pl: "Odrzuć opcjonalne",
  },
  customize: {
    en: "Customize",
    pl: "Dostosuj",
  },
  submitOrder: {
    en: "Submit Order",
    pl: "Złóż Zamówienie",
  },
  cancel: {
    en: "Cancel",
    pl: "Anuluj",
  },
  confirm: {
    en: "Confirm",
    pl: "Potwierdź",
  },
  close: {
    en: "Close",
    pl: "Zamknij",
  },
  viewMenu: {
    en: "View Menu",
    pl: "Zobacz Menu",
  },
  viewCart: {
    en: "View Cart",
    pl: "Zobacz Koszyk",
  },
  share: {
    en: "Share",
    pl: "Udostępnij",
  },
  copiedToClipboard: {
    en: "Copied to clipboard",
    pl: "Skopiowano do schowka",
  },
  checkout: {
    en: "Checkout",
    pl: "Kasa",
  },
  addItem: {
    en: "Add Item",
    pl: "Dodaj Produkt",
  },
  addNewItem: {
    en: "Add New Item",
    pl: "Dodaj Nowy Produkt",
  },
  deleteItem: {
    en: "Delete Item",
    pl: "Usuń Produkt",
  },
  save: {
    en: "Save",
    pl: "Zapisz",
  },
  edit: {
    en: "Edit",
    pl: "Edytuj",
  },
  delete: {
    en: "Delete",
    pl: "Usuń",
  },
  update: {
    en: "Update",
    pl: "Zaktualizuj",
  },
  add: {
    en: "Add",
    pl: "Dodaj",
  },
  addNote: {
    en: "Add a note",
    pl: "Dodaj notatkę",
  },
  remove: {
    en: "Remove",
    pl: "Usuń",
  },
  
  // Messages
  loading: {
    en: "Loading...",
    pl: "Ładowanie...",
  },
  cookieBannerTitle: {
    en: "We use cookies to make the site work and (optionally) to improve it.",
    pl: "Używamy plików cookie, aby Serwis działał i (opcjonalnie) aby go ulepszać.",
  },
  cookieBannerBody: {
    en: "We use essential cookies and optional preference cookies. We do not use analytics or marketing cookies. You can accept, reject optional, or customize.",
    pl: "Używamy niezbędnych plików cookie oraz opcjonalnych plików preferencji. Nie używamy plików analitycznych ani marketingowych. Możesz zaakceptować, odrzucić opcjonalne lub dostosować.",
  },
  cookieSettingsBody: {
    en: "Choose which optional cookie categories you want to allow. Essential cookies (including payments via Stripe) are always on. We do not use analytics or marketing cookies.",
    pl: "Wybierz, na które opcjonalne kategorie chcesz zezwolić. Niezbędne pliki cookie (w tym płatności przez Stripe) są zawsze włączone. Nie używamy plików analitycznych ani marketingowych.",
  },
  cookieCategoryNecessaryAlwaysOn: {
    en: "Necessary (always on)",
    pl: "Niezbędne (zawsze włączone)",
  },
  cookieCategoryPreferences: {
    en: "Preferences",
    pl: "Preferencje",
  },
  cookieCategoryPreferencesDesc: {
    en: "Remembers your settings (e.g. language) to improve your experience.",
    pl: "Zapamiętuje Twoje ustawienia (np. język), aby ułatwić korzystanie z Serwisu.",
  },
  cookieCategoryAnalytics: {
    en: "Analytics",
    pl: "Analityczne",
  },
  cookieCategoryAnalyticsNotUsedDesc: {
    en: "Not used on this site.",
    pl: "Nie są używane w tym Serwisie.",
  },
  cookieCategoryMarketing: {
    en: "Marketing",
    pl: "Marketingowe",
  },
  cookieCategoryMarketingNotUsedDesc: {
    en: "Not used on this site.",
    pl: "Nie są używane w tym Serwisie.",
  },
  cookieSettings: {
    en: "Cookie settings",
    pl: "Ustawienia cookies",
  },
  cookiePolicy: {
    en: "Cookie Policy",
    pl: "Polityka cookies",
  },
  error: {
    en: "An error occurred",
    pl: "Wystąpił błąd",
  },
  success: {
    en: "Success",
    pl: "Sukces",
  },
  successfullyDeletedItem: {
    en: "Successfully deleted item!",
    pl: "Pomyślnie usunięto produkt!",
  },
  
  // Cart
  cartEmpty: {
    en: "Your cart is empty!",
    pl: "Twój koszyk jest pusty!",
  },
  specialInstructionsPlaceholder: {
    en: "Special instructions (e.g. no tomato, sauce on the side)",
    pl: "Specjalne instrukcje (np. bez pomidora, sos z boku)",
  },
  removeItem: {
    en: "Remove Item",
    pl: "Usuń Produkt",
  },
  saveNotes: {
    en: "Save notes",
    pl: "Zapisz notatki",
  },
  editNotes: {
    en: "Edit Notes",
    pl: "Edytuj Notatki",
  },
  hide: {
    en: "Hide",
    pl: "Ukryj",
  },
  sendTextFoodReady: {
    en: "Send Text: Food is Ready",
    pl: "Wyślij SMS: Jedzenie Gotowe",
  },
  sendingText: {
    en: "Sending Text...",
    pl: "Wysyłanie SMS...",
  },
  callToCounter: {
    en: "Call to counter",
    pl: "Wezwanie do lady",
  },
  sendingCallToCounter: {
    en: "Sending Call-to-Counter...",
    pl: "Wysyłanie wezwania do lady...",
  },
  welcomeWitamy: {
    en: "Welcome / Witamy",
    pl: "Welcome / Witamy",
  },
  selectLanguagePrompt: {
    en: "Please select your preferred language",
    pl: "Proszę wybrać preferowany język",
  },
  resendVerificationEmail: {
    en: "Resend verification email",
    pl: "Wyślij ponownie potwierdzenie e-mail",
  },
  copyright: {
    en: "Copyright ©",
    pl: "Prawa autorskie ©",
  },
  myOrder: {
    en: "My Order",
    pl: "Moje Zamówienie",
  },
  item: {
    en: "Item",
    pl: "Produkt",
  },
  items: {
    en: "Items",
    pl: "Produkty",
  },
  qty: {
    en: "Qty",
    pl: "Ilość",
  },
  quantity: {
    en: "Quantity",
    pl: "Ilość",
  },
  total: {
    en: "Total",
    pl: "Suma",
  },
  
  // Menu Items
  menuItems: {
    en: "Menu Items",
    pl: "Produkty Menu",
  },
  viewAndManageMenu: {
    en: "View and manage your menu",
    pl: "Przeglądaj i zarządzaj swoim menu",
  },
  allOrders: {
    en: "All Orders",
    pl: "Wszystkie Zamówienia",
  },
  
  // Food Categories
  food: {
    en: "Food",
    pl: "Jedzenie",
  },
  grill: {
    en: "Grill",
    pl: "Grill",
  },
  drink: {
    en: "Drink",
    pl: "Napoje",
  },
  all: {
    en: "All",
    pl: "Wszystko",
  },
  allFood: {
    en: "All Food",
    pl: "Całe Jedzenie",
  },
  allGrill: {
    en: "All Grill",
    pl: "Cały Grill",
  },
  allDrinks: {
    en: "All Drinks",
    pl: "Wszystkie Napoje",
  },
  
  // Subcategories - Food
  mainPlates: {
    en: "Main Plates",
    pl: "Dania Główne",
  },
  snacksAndFries: {
    en: "Snacks & Fries",
    pl: "Przekąski i Frytki",
  },
  burgersAndKebab: {
    en: "Burgers & Kebab",
    pl: "Burgery i Kebab",
  },
  soups: {
    en: "Soups",
    pl: "Zupy",
  },
  pierogiAndRegional: {
    en: "Pierogi & Regional",
    pl: "Pierogi i Regionalne",
  },
  desserts: {
    en: "Desserts",
    pl: "Desery",
  },
  sweets: {
    en: "Sweets",
    pl: "Słodycze",
  },
  
  // Subcategories - Drinks
  hot: {
    en: "Hot",
    pl: "Gorące",
  },
  cold: {
    en: "Cold",
    pl: "Zimne",
  },
  alcoholic: {
    en: "Alcoholic",
    pl: "Alkoholowe",
  },
  shots: {
    en: "Shots",
    pl: "Shoty",
  },
  
  // Availability
  markAllAvailable: {
    en: "Mark All Available",
    pl: "Oznacz Wszystko Dostępne",
  },
  markAllUnavailable: {
    en: "Mark All Unavailable",
    pl: "Oznacz Wszystko Niedostępne",
  },
  available: {
    en: "Available",
    pl: "Dostępne",
  },
  unavailable: {
    en: "Unavailable",
    pl: "Niedostępne",
  },
  
  // About Page
  bestFoodBestPrices: {
    en: "The best food at the best prices",
    pl: "Najlepsze jedzenie w najlepszych cenach",
  },
  
  // Store Status
  storeClosed: {
    en: "Sorry, our kitchen is closed",
    pl: "Przepraszamy, nasza kuchnia jest zamknięta",
  },

  currency: {
    en: "PLN",
    pl: "zł",
  },
  
  // Checkout
  placeOrder: {
    en: "Place Order",
    pl: "Złóż Zamówienie",
  },
  
  // Menu Page
  yesWeHaveMenu: {
    en: "\"YES! We have a menu!\"",
    pl: "\"TAK! Mamy menu!\"",
  },
  
  // Additional messages
  successfullyAddedToCart: {
    en: "Successfully added to cart!",
    pl: "Pomyślnie dodano do koszyka!",
  },
  successfullyUpdatedItem: {
    en: "Successfully updated item!",
    pl: "Pomyślnie zaktualizowano produkt!",
  },
  backToCart: {
    en: "Back to Cart",
    pl: "Wróć do Koszyka",
  },
  backToCheckout: {
    en: "Back to Checkout",
    pl: "Wróć do Kasy",
  },
  addToCart: {
    en: "Add to Cart",
    pl: "Dodaj do Koszyka",
  },
  summary: {
    en: "Summary",
    pl: "Podsumowanie",
  },
  subtotal: {
    en: "Subtotal",
    pl: "Suma Częściowa",
  },
  orderSummary: {
    en: "Order Summary",
    pl: "Podsumowanie Zamówienia",
  },
  thankYouForOrder: {
    en: "Thank you for your order",
    pl: "Dziękujemy za zamówienie",
  },
  textWhenReady: {
    en: "Keep this page open — it will update when your order is ready for pickup.",
    pl: "Zostaw tę stronę otwartą — zaktualizuje się, gdy zamówienie będzie gotowe do odbioru.",
  },
  paymentStatus: {
    en: "Payment Status:",
    pl: "Status Płatności:",
  },
  paid: {
    en: "Paid",
    pl: "Opłacone",
  },
  ordersLast24hrs: {
    en: "Total Orders",
    pl: "Zamówienia w dniu dzisiejszym",
  },
  newOrders: {
    en: "New Orders",
    pl: "Nowe Zamówienia",
  },
  orderTime: {
    en: "Order Time",
    pl: "Czas Zamówienia",
  },
  orderName: {
    en: "Order Name",
    pl: "Imię",
  },
  totalPrice: {
    en: "Total Price",
    pl: "Cena Całkowita",
  },
  status: {
    en: "Status",
    pl: "Status",
  },
  addedToFiscalPrinter: {
    en: "Added to fiscal printer",
    pl: "Dodane do drukarki fiskalnej",
  },
  pending: {
    en: "Pending",
    pl: "Oczekujące",
  },
  complete: {
    en: "Complete",
    pl: "Zakończone",
  },
  unpaid: {
    en: "Unpaid",
    pl: "Niepłacone",
  },
  orderNumber: {
    en: "Order #",
    pl: "Nr zamówienia",
  },
  viewReview: {
    en: "View Review",
    pl: "Zobacz opinię",
  },
  hideReview: {
    en: "Hide Review",
    pl: "Ukryj opinię",
  },
  leavePersonalFeedback: {
    en: "Leave personal feedback",
    pl: "Zostaw osobistą opinię",
  },
  yourFeedback: {
    en: "Your feedback",
    pl: "Twoja opinia",
  },
  shareFeedbackDirectly: {
    en: "Share your feedback directly with us.",
    pl: "Podziel się swoją opinią bezpośrednio z nami.",
  },
  submitFeedback: {
    en: "Submit feedback",
    pl: "Wyślij opinię",
  },
  feedbackRequired: {
    en: "Please enter your feedback.",
    pl: "Wpisz opinię.",
  },
  feedbackSubmitFailed: {
    en: "Could not submit feedback.",
    pl: "Nie udało się wysłać opinii.",
  },
  feedbackThanks: {
    en: "Thanks for your feedback!",
    pl: "Dziękujemy za opinię!",
  },
  review: {
    en: "Review",
    pl: "Opinia",
  },

  //MenuItemsPage.js
  expandForm: {
    en: "Expand Form",
    pl: "Rozwiń formularz",
  },
  itemName: {
    en: "Item Name",
    pl: "Nazwa produktu",
  },
  itemSize: {
    en: "Item Size",
    pl: "Rozmiar produktu",
  },
  itemSizeQuestion: {
    en: "Item Size?",
    pl: "Rozmiar produktu?",
  },
  price: {
    en: "Price",
    pl: "Cena",
  },
  priceOfSmallItem: {
    en: "Price of Small Item",
    pl: "Cena małego produktu",
  },
  priceOfLargeItem: {
    en: "Price of Large Item",
    pl: "Cena dużego produktu",
  },
  itemDetails: {
    en: "Item Details",
    pl: "Szczegóły produktu",
  },
  itemType: {
    en: "Item Type",
    pl: "Typ produktu",
  },
  itemTypeQuestion: {
    en: "Item Type?",
    pl: "Typ produktu?",
  },
  subcategory: {
    en: "Subcategory",
    pl: "Podkategoria",
  },
  chooseSubcategory: {
    en: "Choose subcategory",
    pl: "Wybierz podkategorię",
  },
  selectItemTypeFirst: {
    en: "Select Item Type first",
    pl: "Najpierw wybierz typ produktu",
  },
  pleaseEnterValidNumber: {
    en: "Please enter a valid number",
    pl: "Proszę wprowadzić prawidłową liczbę",
  },
  mustBeLoggedIn: {
    en: "You must be logged in",
    pl: "Musisz być zalogowany",
  },
  pleaseSetName: {
    en: "Please set name",
    pl: "Proszę ustawić nazwę",
  },
  pleaseSelectItemSize: {
    en: "Please select item size",
    pl: "Proszę wybrać rozmiar produktu",
  },
  pleaseSetPrice: {
    en: "Please set price",
    pl: "Proszę ustawić cenę",
  },
  pleaseSetLargeItemPrice: {
    en: "Please set large item price",
    pl: "Proszę ustawić cenę dużego produktu",
  },
  pleaseSelectFoodOrDrinks: {
    en: "Please select food, grill or drinks",
    pl: "Proszę wybrać jedzenie, grill lub napoje",
  },
  pleaseSelectSubcategory: {
    en: "Please select a subcategory",
    pl: "Proszę wybrać podkategorię",
  },
  pleaseSelectAvailability: {
    en: "Please select availability",
    pl: "Proszę wybrać dostępność",
  },
  errorOccurred: {
    en: "An error occurred, please try again",
    pl: "Wystąpił błąd, spróbuj ponownie",
  },
  updating: {
    en: "Updating...",
    pl: "Aktualizowanie...",
  },
  enableAll: {
    en: "Enable All",
    pl: "Włącz wszystkie",
  },
  disableAll: {
    en: "Disable All",
    pl: "Wyłącz wszystkie",
  },
  size: {
    en: "Size",
    pl: "Rozmiar",
  },
  description: {
    en: "Description",
    pl: "Opis",
  },
  itemSubcategory: {
    en: "Item Subcategory",
    pl: "Podkategoria produktu",
  },
  itemAvailable: {
    en: "Item Available?",
    pl: "Produkt dostępny?",
  },
  yes: {
    en: "Yes",
    pl: "Tak",
  },
  no: {
    en: "No",
    pl: "Nie",
  },
  notSet: {
    en: "Not Set",
    pl: "Nie ustawiono",
  },
  seeMoreDetails: {
    en: "See more details",
    pl: "Zobacz więcej szczegółów",
  },
  editItem: {
    en: "Edit Item",
    pl: "Edytuj produkt",
  },
  areYouSureDelete: {
    en: "Are you sure you want to delete",
    pl: "Czy na pewno chcesz usunąć",
  },
  itemDescription: {
    en: "Item Description",
    pl: "Opis produktu",
  },
  sizeQuestion: {
    en: "Size?",
    pl: "Rozmiar?",
  },
  changeAvailability: {
    en: "Change Availability?",
    pl: "Zmienić dostępność?",
  },
  saveChanges: {
    en: "Save Changes",
    pl: "Zapisz zmiany",
  },
  time: {
    en: "Time",
    pl: "Czas",
  },
  name: {
    en: "Name",
    pl: "Imię",
  },
  details: {
    en: "Details",
    pl: "Szczegóły",
  },
  instructions: {
    en: "Instructions",
    pl: "Instrukcje",
  },
  none: {
    en: "None",
    pl: "Brak",
  },
  open: {
    en: "Open",
    pl: "Otwarte",
  },
  closed: {
    en: "Closed",
    pl: "Zamknięte",
  },
  accountSettings: {
    en: "Account Settings",
    pl: "Ustawienia konta",
  },
  updateEmail: {
    en: "Update Email",
    pl: "Zaktualizuj e-mail",
  },
  security: {
    en: "Security",
    pl: "Bezpieczeństwo",
  },
  password: {
    en: "Password",
    pl: "Hasło",
  },
  updatePassword: {
    en: "Update Password",
    pl: "Zaktualizuj hasło",
  },
  emailedLinkChangeEmail: {
    en: "We have emailed you a link to change your email",
    pl: "Wysłaliśmy Ci link do zmiany adresu e-mail",
  },
  emailedLinkResetPassword: {
    en: "We have emailed you a link to reset your password",
    pl: "Wysłaliśmy Ci link do zresetowania hasła",
  },
  anErrorOccurred: {
    en: "An error occurred, please try again",
    pl: "Wystąpił błąd, spróbuj ponownie",
  },
  specialInstructions: {
    en: "Special instructions (e.g. no tomato, sauce on the side)",
    pl: "Specjalne instrukcje (np. bez pomidora, sos z boku)",
  },

  orderToGoPaySecurely: {
    en: "Order to-go. Pay Securely online.",
    pl: "Zamów na wynos. Płać bezpiecznie online.",
  },
  customizeItem: {
    en: "Customize item (optional)",
    pl: "Dostosuj produkt (opcjonalnie)",
  },
  hideCustomization: {
    en: "Hide customization",
    pl: "Ukryj dostosowanie",
  },
  privacyPolicy: {
    en: "Privacy Policy",
    pl: "Polityka Prywatności",
  },
  termsAndConditions: {
    en: "Terms & Conditions",
    pl: "Regulamin",
  },
  customerInformation: {
    en: "Customer Information",
    pl: "Informacje o Kliencie",
  },
  paymentMethod: {
    en: "Payment Method",
    pl: "Metoda Płatności",
  },
  submitPayment: {
    en: "Submit Payment",
    pl: "Wyślij Płatność",
  },
  totalToPay: {
    en: "Total to pay",
    pl: "Do zapłaty",
  },
  payment: {
    en: "Payment",
    pl: "Płatność",
  },
  firstName: {
    en: "First Name",
    pl: "Imię",
  },
  lastName: {
    en: "Last Name",
    pl: "Nazwisko",
  },
  phoneNumber: {
    en: "Phone Number",
    pl: "Numer Telefonu",
  },
  email: {
    en: "Email",
    pl: "E-mail",
  },
  emailCopyOfOrder: {
    en: "We will email you a copy of your order",
    pl: "Wyślemy Ci kopię zamówienia na e-mail",
  },
  small: {
    en: "Small",
    pl: "Mała",
  },
  large: {
    en: "Large",
    pl: "Duża",
  },
  oneSize: {
    en: "One Size",
    pl: "Jeden Rozmiar",
  },
  largeAndSmall: {
    en: "Large & Small",
    pl: "Duży i mały",
  },
  alcoholWarning: {
    en: "Alcoholic items detected — customers must be 18+ with a valid ID at pickup.",
    pl: "Wykryto produkty alkoholowe — klienci muszą mieć ukończone 18 lat z ważnym dowodem osobistym przy odbiorze.",
  },
  
  // FAQ Section
  frequentlyAskedQuestions: {
    en: "Frequently Asked Questions",
    pl: "Często Zadawane Pytania",
  },
  hoursOfOperation: {
    en: "Hours of Operation",
    pl: "Godziny Otwarcia",
  },
  monday: {
    en: "Monday",
    pl: "Poniedziałek",
  },
  tuesday: {
    en: "Tuesday",
    pl: "Wtorek",
  },
  wednesday: {
    en: "Wednesday",
    pl: "Środa",
  },
  thursday: {
    en: "Thursday",
    pl: "Czwartek",
  },
  friday: {
    en: "Friday",
    pl: "Piątek",
  },
  saturday: {
    en: "Saturday",
    pl: "Sobota",
  },
  sunday: {
    en: "Sunday",
    pl: "Niedziela",
  },
  whatKindOfFood: {
    en: "What kind of food do we serve?",
    pl: "Jaki rodzaj jedzenia serwujemy?",
  },
  whatKindOfFoodAnswer: {
    en: "We offer a wide variety of dishes to satisfy every taste. Our menu includes everything from classic comfort foods to local traditional cuisine. Whether you're craving fresh meat, or gourmet appetizers, we have something for everyone. If you have any special dietary needs or preferences, don't hesitate to ask, and we'll do our best to accommodate you!",
    pl: "Oferujemy szeroką gamę dań, aby zaspokoić każdy gust. Nasze menu obejmuje wszystko, od klasycznych potraw po lokalną tradycyjną kuchnię. Niezależnie od tego, czy masz ochotę na świeże mięso czy wykwintne przystawki, mamy coś dla każdego. Jeśli masz szczególne potrzeby dietetyczne lub preferencje, nie wahaj się zapytać, a zrobimy co w naszej mocy, aby Ci pomóc!",
  },
  howToOrderOnline: {
    en: "How can I order online?",
    pl: "Jak mogę zamówić online?",
  },
  howToOrderOnlineAnswer: {
    en: "Ordering online is easy! Just visit our Order page on our website. Once there, you can browse our full menu, select items, and add them to your cart. You'll be able to choose your payment method and delivery options. After placing your order, you'll receive a confirmation email with detailed information.",
    pl: "Zamawianie online jest łatwe! Po prostu odwiedź stronę Zamów na naszej stronie internetowej. Tam możesz przeglądać nasze pełne menu, wybierać produkty i dodawać je do koszyka. Będziesz mógł wybrać metodę płatności i opcje dostawy. Po złożeniu zamówienia otrzymasz e-mail z potwierdzeniem ze szczegółowymi informacjami.",
  },

  // Menu Items
  "Nestea lemon": {
    en: "Nestea lemon",
    pl: "Nestea cytrynowa",
  },
  "Nestea peach": {
    en: "Nestea peach",
    pl: "Nestea brzoskwiniowa",
  },
  "Tymbark apple kiwi": {
    en: "Tymbark apple kiwi",
    pl: "Tymbark jabłko kiwi",
  },
  "Nestea citrus": {
    en: "Nestea citrus",
    pl: "Nestea cytrusowa",
  },
  "Jagermeister 100ml": {
    en: "Jagermeister 100ml",
    pl: "Jagermeister 100ml",
  },
  "Jagermeister shot": {
    en: "Jagermeister shot",
    pl: "Jagermeister shot",
  },
  "Soplica orzecz laskowy 100ml": {
    en: "Soplica hazelnut 100ml",
    pl: "Soplica orzech laskowy 100ml",
  },
  "Soplica wiśniowa 100ml": {
    en: "Soplica cherry 100ml",
    pl: "Soplica wiśniowa 100ml",
  },
  "Soplica pigwowa 100ml": {
    en: "Soplica quince 100ml",
    pl: "Soplica pigwowa 100ml",
  },
  "Pork knuckle with cabbage, bread, and sauces": {
    en: "Pork knuckle with cabbage, bread, and sauces",
    pl: "Golonka wieprzowa z kapustą, chlebem i sosami",
  },
  "Beef Tripe Soup": {
    en: "Beef Tripe Soup",
    pl: "Flaczki",
  },
  "Sour rye soup with egg and sausage + bread": {
    en: "Sour rye soup with egg and sausage + bread",
    pl: "Żurek z jajkiem i kiełbasą + pieczywo",
  },
  "Chicken and Fries Maxi set": {
    en: "Chicken and Fries Maxi set",
    pl: "Kurczak i Frytki Maxi set",
  },
  "Chicken Strips (10)": {
    en: "Chicken Strips (10)",
    pl: "Zestaw 10 strips",
  },
  "Chicken Strips (15)": {
    en: "Chicken Strips (15)",
    pl: "Zestaw 15 strips",
  },
  "Tiramisu": {
    en: "Tiramisu",
    pl: "Tiramisu",
  },
  "Waffles with Powdered Sugar": {
    en: "Waffles with Powdered Sugar",
    pl: "Gofry z cukrem pudrem",
  },
  "Waffles with topping": {
    en: "Waffles with topping",
    pl: "Gofry z polewą",
  },
  "Espresso": {
    en: "Espresso",
    pl: "Espresso",
  },
  "Coffee with Milk": {
    en: "Coffee with Milk",
    pl: "Kawa z mlekiem",
  },
  "Hot Chocolate with Whipped Cream": {
    en: "Hot Chocolate with Whipped Cream",
    pl: "Czekolada na gorąco z bitą śmietana",
  },  "Hot spiced apple juice (non-alcoholic)": {
    en: "Hot spiced apple juice (non-alcoholic)",
    pl: "Grzaniec jabłkowy (bezalk.)",
  },
  "Tea with Lemon": {
    en: "Tea with Lemon",
    pl: "Herbata z Cytryną",
  },
  "Winter Tea": {
    en: "Winter Tea",
    pl: "Herbata Zimowa",
  },  "1664 Blanc Draft Beer": {
    en: "1664 Blanc Draft Beer",
    pl: "1664 Blanc Piwo z Beczki",
  },
  "Irish Coffee": {
    en: "Irish Coffee",
    pl: "Irish Coffee",
  },
  "Highlander-Style Tea": {
    en: "Highlander-Style Tea",
    pl: "Herbata Po Góralsku",
  },
  "Tea with Cherry Vodka": {
    en: "Tea with Cherry Vodka",
    pl: "Herbata z Wiśniówką",
  },
  "Tea with Rum, Honey, Orange, and Cinnamon": {
    en: "Tea with Rum, Honey, Orange, and Cinnamon",
    pl: "Herbata z Rumem, Miodem, Pomarańczą i Cynamonem",
  },
  "Sour cabbage soup with pork rib, potatoes, and bread": {
    en: "Sour cabbage soup with pork rib, potatoes, and bread",
    pl: "Kwaśnica z żeberkiem ziemniakami i pieczywem",
  },
  "French Fries": {
    en: "French Fries",
    pl: "Frytki",
  },
  "Aperol Spritz": {
    en: "Aperol Spritz",
    pl: "Aperol Spritz",
  },
  "Aperol Rose Spritz": {
    en: "Aperol Rose Spritz",
    pl: "Aperol Rosé Spritz",
  },
  "Warm Beer With Honey, Orange and Spices": {
    en: "Warm Beer With Honey, Orange and Spices",
    pl: "Piwo Grzane z Miodem i Przyprawami",
  },
  "Warm Beer with Juice (Raspberry or Ginger)": {
    en: "Warm Beer with Juice (Raspberry or Ginger)",
    pl: "Piwo Grzane z Sokiem (malina lub imbir)",
  },
  "Bombardino": {
    en: "Bombardino",
    pl: "Bombardino",
  },
  "Hot chocolate with rum or nut vodka": {
    en: "Hot chocolate with rum or nut vodka",
    pl: "Czekolada z rumem lub orzechówką",
  },
  "Hot chocolate with cherry vodka": {
    en: "Hot chocolate with cherry vodka",
    pl: "Czekolada na wiśniówce",
  },
  "Mulled Wine": {
    en: "Mulled Wine",
    pl: "Grzaniec (wino)",
  },
  "Warm Honey (Mead)": {
    en: "Warm Honey (Mead)",
    pl: "Miód pitny (trójniak)",
  },
  "Tea with Raspberries": {
    en: "Tea with Raspberries",
    pl: "Herbata z Malinami",
  },
  "Mocha Coffee": {
    en: "Mocha Coffee",
    pl: "Kawa mocha",
  },
  "Black Coffee": {
    en: "Black Coffee",
    pl: "Kawa Czarna",
  },
  "Jam-Filled Donut": {
    en: "Jam-Filled Donut",
    pl: "Pączek",
  },
  "Chocolate wafers": {
    en: "Chocolate wafers",
    pl: "Andrut z czekoladą",
  },
  "Cheese Cake": {
    en: "Cheese Cake",
    pl: "Sernik",
  },
  "Waffles with Whipped Cream": {
    en: "Waffles with Whipped Cream",
    pl: "Gofry z bitą smietana",
  },
  "Waffles with Whipped Cream and Fruit": {
    en: "Waffles with Whipped Cream and Fruit",
    pl: "Gofry z bitą smietana i owocami",
  },
  "Chicken and Fries Mini Set": {
    en: "Chicken and Fries Mini Set",
    pl: "Zestaw mini",
  },
  "Chicken Strips (20)": {
    en: "Chicken Strips (20)",
    pl: "Zestaw 20 strips",
  },
  "Crepes with cottage cheese and whipped cream": {
    en: "Crepes with cottage cheese and whipped cream",
    pl: "Naleśniki z serem i bitą śmietana",
  },
  "Sour rye soup (cup)": {
    en: "Sour rye soup (cup)",
    pl: "Żurek solo (kubek)",
  },
  "Beet soup with croquette": {
    en: "Beet soup with croquette",
    pl: "Barszczyk z krokietem",
  },
  "Pork cutlet set with fries and salads": {
    en: "Pork cutlet set with fries and salads",
    pl: "Zestaw schabowy + frytki i surówki",
  },
  "Chicken Kebab in a Tortilla": {
    en: "Chicken Kebab in a Tortilla",
    pl: "Kebab w tortilli (drobiowy)",
  },
  "Highlander-Style Kebab": {
    en: "Highlander-Style Kebab",
    pl: "Kebab po góralsku",
  },
  "Toasted baguette with cheese and mushrooms": {
    en: "Toasted baguette with cheese and mushrooms",
    pl: "Zapiekanka z serem i pieczarkami",
  },
  "Toasted Baguette with Regional Cheese": {
    en: "Toasted Baguette with Regional Cheese",
    pl: "Zapiekanka z oscypkiem",
  },
  "French Hot-dog": {
    en: "French Hot-dog",
    pl: "Hot-dog Francuski",
  },
  "Hot-dog with vegetables": {
    en: "Hot-dog with vegetables",
    pl: "Hot-dog z warzywami",
  },
  "Highlander-Style Moskol": {
    en: "Highlander-Style Moskol",
    pl: "Moskol po zbójnicku",
  },
  "Moskol with Garlic Butter / Lard Spread": {
    en: "Moskol with Garlic Butter / Lard Spread",
    pl: "Moskol z masłem czosnkowym lub smalcem",
  },
  "Bread with Lard Spread and Pickle": {
    en: "Bread with Lard Spread and Pickle",
    pl: "Chleb ze smalcem i ogórkiem",
  },
  "Potatoe Wedges": {
    en: "Potatoe Wedges",
    pl: "Frytki łódeczki",
  },
  "Cheese Fries": {
    en: "Cheese Fries",
    pl: "Frytki z serem",
  },
  "Apple pie": {
    en: "Apple pie",
    pl: "Szarlotka",
  },
  "Kebab set with fries and salad": {
    en: "Kebab set with fries and salad",
    pl: "Zestaw kebab + frytki + surówki",
  },
  "Pulled pork sandwich with bacon and regional cheese": {
    en: "Pulled pork sandwich with bacon and regional cheese",
    pl: "Kanapka Harnasia",
  },
  "Pulled pork regional moskol": {
    en: "Pulled pork regional moskol",
    pl: "Moskol harnasia",
  },
  "Red Beet Soup (cup)": {
    en: "Red Beet Soup (cup)",
    pl: "Barszczyk Czerwony solo (kubek)",
  },
  "Russian Dumplings (potato & cheese)": {
    en: "Russian Dumplings (potato & cheese)",
    pl: "Pierogi ruskie",
  },
  "Prince Polo XXL classic": {
    en: "Prince Polo XXL classic",
    pl: "Prince Polo XXL classic",
  },
  "Twix": {
    en: "Twix",
    pl: "Twix",
  },
  "KitKit chunky white": {
    en: "KitKit chunky white",
    pl: "KitKit chunky white",
  },
  "Lion": {
    en: "Lion",
    pl: "Lion",
  },
  "Test item": {
    en: "Test item",
    pl: "Przedmiot testowy",
  },
  "Toasted Baguette with Chicken": {
    en: "Toasted Baguette with Chicken",
    pl: "Zapiekanka z kurczakiem",
  },
  "Pulled pork sandwich": {
    en: "Pulled pork sandwich",
    pl: "Kanapka zbója",
  },
  "Chilli Soup": {
    en: "Chilli Soup",
    pl: "Zupa Chilli",
  },
  "hunters stew": {
    en: "hunters stew",
    pl: "bigos",
  },
  "Dumplings with Meat": {
    en: "Dumplings with Meat",
    pl: "Pierogi z mięsem",
  },
  "Waffles with Jam": {
    en: "Waffles with Jam",
    pl: "Gofry z dżemem",
  },
  "Apple Pie with whipped cream": {
    en: "Apple Pie with whipped cream",
    pl: "Szarlotka z bitą śmietaną",
  },
  "Flat White Coffee": {
    en: "Flat White Coffee",
    pl: "Flat White kawa",
  },
  "Mirinda orange (bottle)": {
    en: "Mirinda orange (bottle)",
    pl: "Mirinda pomarańczowa (butelka)",
  },
  "Water (non-carbonated)": {
    en: "Water (non-carbonated)",
    pl: "Woda (niegazowana)",
  },
  "Water (carbonated)": {
    en: "Water (carbonated)",
    pl: "Woda (gazowana)",
  },
  "Perła Draft Beer": {
    en: "Perła Draft Beer",
    pl: "Perła Piwo z Beczki",
  },
  "Blood Sausage": {
    en: "Blood Sausage",
    pl: "Kaszanka",
  },
  "Sausage": {
    en: "Sausage",
    pl: "Kiełbasa",
  },
  "Cheese with cranberry": {
    en: "Cheese with cranberry",
    pl: "Serek z żurawiną",
  },
  "Pork neck": {
    en: "Pork neck",
    pl: "Karczek",
  },
};

export default translations;